<div class="app-table-container">
  <!--  ШАБЛОН ДЛЯ ВЫВОДА ИНФОРМАЦИИ ПРИ ЗАДАННОМ УСЛОВИИ -->
  @if (disable) {
    <div class="missing">
      <img src="assets/img/404.svg" alt="">
      <ng-content select="app-disable-table"></ng-content>
    </div>
  } @else {
    @if (loadError) {
      <div class="load-error" role="alert">
        <span>{{ currentPageData.length ? ('TABLE.refresh_failed' | translate) : ('TABLE.load_failed' | translate) }}</span>
        <button (click)="dataReloader$.next(true)" type="button" mat-button color="primary">{{ 'TABLE.retry' | translate }}</button>
      </div>
    }
    <table [dataSource]="dataSource$" [trackBy]="trackByIndex" class="full-width" mat-table>
      <!-- SELECTION  -->
      @if (withSelection) {
        <app-selection (changed)="selectionChanged.emit($event)"
          [idAccessor]="idAccessor"
          [resetter]="selectionResetter">
        </app-selection>
      }
      @for (ref of columnRefs; track ref) {
        <ng-container [matColumnDef]="ref.colName">
          <th *matHeaderCellDef [ngClass]="'app-table-cell-' + ref.colName" class="app-table-cell" mat-header-cell>
            <ng-container [ngTemplateOutlet]="$safeNavigationMigration(ref.header?.templateRef)"></ng-container>
          </th>
          <td *matCellDef="let row" [ngClass]="'app-table-cell-' + ref.colName" class="app-table-cell" mat-cell>
            <ng-container [ngTemplateOutletContext]="{$implicit: $safeNavigationMigration(ref.column?.convertRow(row))}"
              [ngTemplateOutlet]="$safeNavigationMigration(ref.column?.templateRef)">
            </ng-container>
          </td>
        </ng-container>
      }
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      @if (tableRow) {
        <tr (click)="tableRow?.rowClick.emit(row)"
          *matRowDef="let row; columns: displayedColumns;"
          [ngClass]="getRowClasses(row)"
          mat-row>
        </tr>
      } @else {
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
      }
    </table>
    <!--  LOADER & PLACEHOLDER TEXT  -->
    @if (loading && (!totalCount || !orderColumns)) {
      <app-loader [isLocal]="true"></app-loader>
    }
    @if (!loading && !loadError && !totalCount) {
      <app-not-found [text]="noDataText"></app-not-found>
    }
    @if (loading && !totalCount) {
      <app-not-found [text]="dataLoadingText"></app-not-found>
    }
    <!--  PAGINATOR  -->
    @if (loadingType === 'paginated') {
      <mat-paginator (page)="onPage($event)"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="limit">
      </mat-paginator>
    }
  }

</div>
